import { Routes, Route, useLocation } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";

// Pages
import About from "../pages/About";
import Blog from "../pages/Blog";
import BlogDetail from "../components/blog/BlogDetail";
import NotFound from "../pages/NotFound";
import IndexPage from "../pages";
import Contact from "../pages/Contact";
import LegalPage from "../components/common/LegalPage";
import IndustryDetails from "../pages/IndustryDetails";
import ServiceDetails from "../pages/ServiceDetails";
import SolutionDetails from "../pages/SolutionDetails";
import DigitalMarketingDetails from "../pages/DigitalMarketingDetails";
import { useEffect, useState } from "react";
import Preloader from "../components/_App/Preloader";
import WhatsApp from "../components/_App/WhatsApp";

export default function AppRoutes() {
  const location = useLocation();
const [loading, setLoading] = useState(true);
useEffect(() => {
  setLoading(true);

  const timer = setTimeout(() => {
    setLoading(false);
  }, 400);

  return () => clearTimeout(timer);
}, [location.pathname]);
  return (
    <>
      {loading && <Preloader />}
      

    <Routes>
      {/* Layout wrapper */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<IndexPage />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/services/:slug" element={<ServiceDetails />} />
        <Route path="/digital-marketing/:slug" element={<DigitalMarketingDetails />} />
        <Route path="/solutions/:slug" element={<SolutionDetails />} />
        <Route path="/industries/:slug" element={<IndustryDetails />} />
        <Route path="/industries/:parentSlug/:slug" element={<IndustryDetails />} />


        {/* Blog */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

        <Route path="/:slug" element={<LegalPage />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
        <Route path="/404" element={<NotFound />} />
      </Route>
    </Routes>
    {!loading && <WhatsApp />}
    </>
  );
}
